var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex gl-flex-col gl-items-start gl-gap-3 gl-pt-3 md:gl-flex-row"},[_c('h1',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.titleHtml),expression:"titleHtml"}],staticClass:"title gl-heading-1 !gl-m-0",class:{
      'issue-realtime-pre-pulse': _vm.preAnimation,
      'issue-realtime-trigger-pulse': _vm.pulseAnimation,
    },attrs:{"data-testid":"issue-title","dir":"auto"}}),_vm._v(" "),_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }